module.exports = require("webpack-manifest-plugin");